import { DiContainer } from '@/modules/di/di-container';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { LogisticMixingService } from '../services/logistics-mixing.service';
import { IRangeApiObject } from '../ts/logistics.types';
const logisticsService = DiContainer.get(LogisticMixingService);

export interface ILogisticRange {
  id?: number | null,
  start: number;
  border: number;
  priceForPart: number;
}

const initialState: ILogisticRange[] = [
  {
    id: null,
    start: 1,
    border: 100,
    priceForPart: 0,
  },
];
// STORE INITIALIZATION
export const $logisticRanges = createStore(initialState);
export const $logisticRangesLoading = createStore({ loading: false, error: false });

// EVENTS
export const setLogisticRanges = createEvent<ILogisticRange[]>();
const setLogisticRangesFromApi = createEvent<IRangeApiObject[]>();
export const addLogisticRange = createEvent<ILogisticRange>();
export const editLogisticRange = createEvent<{ idx: number; data: ILogisticRange }>();
export const removeLogisticRange = createEvent<{ idx: number }>();

const setRangesLoadingData = createEvent<{ loading: boolean, error: boolean }>();

$logisticRangesLoading.on(setRangesLoadingData, (_state, payload) => {
    return payload;
});

$logisticRanges
  .on(setLogisticRangesFromApi, (state, payload: IRangeApiObject[]) => {
    if (payload.length < 1) return state;
    const reformedData: ILogisticRange[] = payload.map((item: IRangeApiObject) => ({
        id: item.range_id,
        start: item.range_start_km,
        border: item.range_end_km,
        priceForPart: item.range_price_per_ton,
    }))
    return reformedData;
  })
  .on(setLogisticRanges, (_state, payload) => {
    return payload;
  })
  .on(addLogisticRange, (state, payload) => {
    return [...state, payload];
  })
  .on(editLogisticRange, (state, payload) => {
    return state.map((item, i) => {
      if (i === payload.idx) {
        return payload.data;
      }
      return item;
    });
  })
  .on(removeLogisticRange, (state, payload) => {
    const st = [...state];
    if (state.length === 1) return state;
    payload.idx > -1 ? st.splice(payload.idx, 1) : st;
    return st;
  });

export const fetchLogisticRanges = createEffect(async () => {
  try {
    setRangesLoadingData({ loading: true, error: false });
    const res = await logisticsService.getRanges();
    setRangesLoadingData({ loading: false, error: false });
    return res;
  } catch (err) {
    setRangesLoadingData({ loading: false, error: true });
    return { error: err };
  }
});

sample({
  target: setLogisticRangesFromApi,
  clock: fetchLogisticRanges.doneData,
});
